import { Add, Check, Close, Delete, Edit } from '@mui/icons-material';
import { AppBar, Button, Chip, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip, Typography, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import { useDispatch, useSelector } from 'react-redux';
import { deleteMarketingInitiative, enableDisableMarketingInitiative, fetchAllMarketingInitiatives } from '../../../actions/marketingInitiativeActions';
import Swal from 'sweetalert2';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

const MarketingInitiativePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector(state => state.initiatives.loading);
    const initiatives = useSelector(state => state.initiatives.initiatives);

    useEffect(() => {
        dispatch(fetchAllMarketingInitiatives());
    }, []);

    const handleDelete = (id) => {
        Swal.fire({
            title: `Are you sure?`,
            text: 'You will not be able to recover this marketing initiative!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel'
        }).then((result) => {
            if (result.value) {
                dispatch(deleteMarketingInitiative(id));
            }
        });
    }

    const handleActivate = (id, is_active) => {
        Swal.fire({
            title: `Are you sure?`,
            text: `You will ${is_active ? 'deactivate' : 'activate'} this marketing initiative!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Yes, ${is_active ? 'deactivate' : 'activate'} it!`,
            cancelButtonText: 'No, cancel'
        }).then((result) => {
            if (result.value) {
                dispatch(enableDisableMarketingInitiative(id, !is_active));
            }
        });
    }

    const handleEdit = resource => {
        navigate(`/marketing-initiatives/${resource.id}/edit`);
    }

    return (
        <MainContentContainer>
            <LoadingBackdrop open={loading} />
            <AppBar position="sticky">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Marketing Initiatives
                    </Typography>
                    <Button color="inherit" component={Link} to={`/marketing-initiatives/create`} startIcon={<Add />}>
                        Add New
                    </Button>
                </Toolbar>
            </AppBar>
            <Box sx={{ py: 2 }}>
                <TableContainer
                    component={Paper}
                    sx={{
                        marginTop: 3,
                        boxShadow: 2,
                        borderRadius: 1,
                        overflow: 'hidden',
                    }}
                >
                    <Table aria-label="marketing initiatives table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong>Code</strong></TableCell>
                                <TableCell className="text-center"><strong>User count</strong></TableCell>
                                <TableCell><strong>Title / Description</strong></TableCell>
                                <TableCell><strong>Unlocked Duration</strong></TableCell>
                                <TableCell><strong>Status</strong></TableCell>
                                <TableCell><strong>Created On</strong></TableCell>
                                <TableCell align="right"><strong>Actions</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {initiatives
                                .map((initiative) => (
                                    <TableRow key={`initiative-${initiative.id}`}>
                                        <TableCell>{initiative.code}</TableCell>
                                        <TableCell className="text-center">{initiative.user_count}</TableCell>
                                        <TableCell>
                                            <Typography variant="subtitle1">{initiative.name}</Typography>
                                            <Typography variant="body2" color="textSecondary">{initiative.description}</Typography>
                                        </TableCell>
                                        <TableCell>{initiative.default_unlock_duration} {initiative.default_unlock_duration === 1 ? 'day' : 'days'}</TableCell>
                                        <TableCell>
                                            {
                                                initiative.is_active ? (
                                                    <Chip label="Active" color="success" />
                                                ) : (
                                                    <Chip label="Inactive" color="error" />
                                                )
                                            }
                                        </TableCell>
                                        <TableCell>{new Date(initiative.created_at).toLocaleDateString()}</TableCell>
                                        <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                                            <Tooltip title={initiative.is_active ? 'Deactivate' : 'Activate'} placement="top">
                                                <IconButton color={initiative.is_active ? 'error' : 'success'} onClick={() => handleActivate(initiative.id, initiative.is_active)}>
                                                    {initiative.is_active ? <Close /> : <Check />}
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Edit" placement="top">
                                                <IconButton color="info" onClick={() => handleEdit(initiative)}>
                                                    <Edit />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete" placement="top">
                                                <IconButton color="error" onClick={() => handleDelete(initiative.id)}>
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </MainContentContainer>
    )
}

export default MarketingInitiativePage;